import { createI18n } from "vue-i18n";
import enJson from "@/json/localizes/en.localize.json";
import kmJson from "@/json/localizes/km.localize.json";
import { i18nLocale } from "@/services/utils/helper.util";
import { localization } from "@/dto/local.key.dto";

type LanguageData = {
  children: {
    key: string;
    en: string;
    km: string;
  }[];
};

export const setLocalization = (data: LanguageData[]) => {
  const en: Record<string, string> = {
    "": "",
    "dsi-option": "",
    "dsi-admin": "DSI Admin",
    "DSI Admin": "DSI Admin",
  };
  const km: Record<string, string> = {
    "": "",
    "dsi-option": "",
    "dsi-admin": "DSI Admin",
    "DSI Admin": "DSI Admin",
  };

  data.forEach((lang) => {
    lang.children.forEach((child) => {
      en[child.key] = child.en;
      km[child.key] = child.km;
    });
  });

  return {
    en: en,
    km: km,
  };
};

const localStorageData = localStorage.getItem("localizeValue");
const langs = localStorageData ? JSON.parse(localStorageData) : null;

const i18n = createI18n({
  legacy: false,
  locale: i18nLocale.value,
  messages: {
    en: langs?.en || enJson,
    km: langs?.km || kmJson,
  },
});

function changeLocale(locale: "en" | "km"): void {
  i18n.global.locale.value = locale;
  localStorage.setItem(localization, locale);
  i18nLocale.value = locale;
}

export { i18n, changeLocale };
